"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.TicketWaitSession = void 0;

class TicketWaitSession {
  constructor(common) {
    this.pollingIntervalMillis = 3000;
    this.common = common;
  }

  setWaitingTicket(ticketWaitInfo) {
    this.ticketWaitInfo = ticketWaitInfo;

    if (this.ui) {
      this.loadTicketInfoToUi();
    }
  }

  startSession(actionContext, clientContext) {
    console.log("------------TicketWaitSession--------------");
    this.clientContext = clientContext;
    this.common.setAriaBusy(this.clientContext);
    this.ui = this.createUi();
    this.loadTicketInfoToUi();
    this.common.unsetAriaBusy(this.clientContext);
    this.ui.fadeIn();
  }

  endSession() {
    this.common.clearContainer(this.clientContext);
    this.ui = null;
    this.abortPolling();
  }

  promiseInput() {
    return new Promise((accept, reject) => {
      this.currentInputPromiseResolver = input => {
        this.currentInputPromiseResolver = null;
        return accept(input);
      };

      this.startPolling();
    });
  }

  startPolling() {
    this.pollingTimer = setTimeout(() => {
      if (this.currentInputPromiseResolver) {
        this.currentInputPromiseResolver(com.ts.mobile.sdk.InputOrControlResponse.createInputResponse(com.ts.mobile.sdk.TicketWaitInput.createPollRequest()));
      }

      this.pollingTimer = null;
    }, this.pollingIntervalMillis);
  }

  abortPolling() {
    if (this.pollingTimer) {
      clearTimeout(this.pollingTimer);
      this.pollingTimer = null;
    }
  }

  createUi() {
    let uiContentBody = $('<div class="xmuiCore xmuiForm xmuiMobileAuthForm" style="display:none;">\
                <div class="xmuiFullHeightContentBelowPrompt">\
                    <div class="xmuiLoginInstructionsLabel"></div>\
                    <div class="xmuiTicketText" style="display:none;"></div>\
                    <div>\
                        <img class="xmuiTicketImg" style="display:none;"/></img>\
                    </div>\
                    <div class="xmuiSpinner xmuiInProgress"></div>\
                </div>\
            </div>');
    this.common.prependPageHeader(uiContentBody, "ticketWait", i => {
      this.currentInputPromiseResolver(i);
    });
    this.common.appendElement(uiContentBody, this.clientContext);
    return uiContentBody;
  }

  loadTicketInfoToUi() {
    if (this.ticketWaitInfo) {
      if (this.ticketWaitInfo.getTicketId()) {
        try {
          switch (this.ticketWaitInfo.getTicketId().getFormat()) {
            case com.ts.mobile.sdk.TicketIdFormat.Alphanumeric:
              let text = this.ui.find(".xmuiTicketText");
              text.text(this.ticketWaitInfo.getTicketId().getValue());
              text.show();
              break;

            case com.ts.mobile.sdk.TicketIdFormat.Qr:
              let img = this.ui.find(".xmuiTicketImg");
              img.attr("src", "data:image/jpeg;base64," + this.ticketWaitInfo.getTicketId().getValue());
              img.show();
              break;

            default:
              this.common.log("Unsupported ticket ID format");
              throw new Error("Unsupported ticket ID format");
          }
        } catch (e) {
          this.common.log("Error in loadTicketInfoToUi(), not displaying ticket : " + e);
        }
      }

      this.ui.find(".xmuiLoginInstructionsLabel").text(this.ticketWaitInfo.getText());
      this.ui.find(".xmuiPageHeader span").text(this.ticketWaitInfo.getTitle());
    }
  }

}

exports.TicketWaitSession = TicketWaitSession;


// WEBPACK FOOTER //
// ../widget-metro-soft-token/scripts/waitableTicket.js